<template>
  <div>
    <div v-if="flyTalks.length" class="fly-talks-container">
      <div class="fly-talk" v-for="flyTalk in flyTalks" v-bind:key="flyTalk.id">
        <div class="fly-talk-title">{{ flyTalk.name }}</div>
        <div class="fly-talk-time">
          {{ getDayInCroatian(new Date(flyTalk.starts).getDay()) }}, {{ flyTalk.starts | filterDateTimeFromDate }} -
          {{ flyTalk.ends | filterTimeFromDate }}
        </div>
        <div class="fly-talk-box">
          <div class="fly-talk-company-images">
            <div v-for="eventCompany in flyTalk.eventCompanies" v-bind:key="eventCompany.companyId">
              <div v-if="eventCompany.company">
                <img
                  v-bind:class="getCompanyNameNormalized(eventCompany.company.name)"
                  :src="getCompanyLogo(eventCompany.company.name)"
                  v-bind:alt="`${eventCompany.company.name} logo`"
                />
              </div>
            </div>
          </div>
          <div class="fly-talk-button-wrapper" v-show="new Date(flyTalk.starts) > new Date()">
            <button
              v-if="appliedFlyTalksIds.indexOf(flyTalk.id) === -1"
              v-bind:class="[
                'fly-talks-apply',
                appliedFlyTalksIds.indexOf(flyTalk.id) === -1 && flyTalksDisabledIds.indexOf(flyTalk.id) !== -1
                  ? 'max-participants'
                  : '',
              ]"
              v-on:click="openApplicationModal(flyTalk)"
            >
              Prijavi se
            </button>
            <button v-else class="fly-talks-unapply" v-on:click="removeFlyTalk(flyTalk.id)">Ukloni prijavu</button>
          </div>
        </div>
      </div>
    </div>
    <p class="not-ready-notice" v-else>Skupine za fly talks su u pripremi. Više informacija uskoro!</p>
    <FlyTalkApplication
      v-if="applicationModalIsVisible"
      v-on:close="closeApplicationModal"
      v-on:apply="applyToFlyTalk"
      :flyTalk="openedFlyTalkGroup"
    />
  </div>
</template>

<script>
import { sponsorLogoExtensions } from '@/config';

import FlyTalkApplication from '../Fly-talks/FlyTalkApplication';
export default {
  name: 'FlyTalkGroups',
  components: { FlyTalkApplication },
  data() {
    return {
      flyTalks: [],
      flyTalksDisabledIds: [],
      appliedFlyTalksIds: [],
      applicationModalIsVisible: false,
      openedFlyTalkGroup: {},
      openedFlyTalkGroupId: null,
      sponsorLogoExtensions,
    };
  },
  mounted() {
    this.$axios.get(`${this.$API_URL}/events/fly-talks`).then(response => {
      this.flyTalks = response.data;

      for (let flyTalk of this.flyTalks) {
        flyTalk.eventCompanies = flyTalk.eventCompanies.sort((firstEventCompany, secondEventCompany) =>
          firstEventCompany.company.name < secondEventCompany.company.name ? -1 : 1,
        );

        this.$axios.get(`${this.$API_URL}/events/number-of-participants/${flyTalk.id}`).then(response => {
          if (response.data >= flyTalk.maxParticipants) this.flyTalksDisabledIds.push(flyTalk.id);
        });
      }
    });

    this.$axios.get(`${this.$API_URL}/user/applied-fly-talks`).then(response => {
      this.appliedFlyTalksIds = response.data.map(flyTalk => flyTalk.id);
    });
  },
  methods: {
    openApplicationModal: function(flyTalk) {
      if (this.flyTalksDisabledIds.includes(flyTalk.id)) {
        alert('Već je prijavljen maksimalan broj sudionika za taj događaj.');

        return;
      }
      if (this.appliedFlyTalksIds.length > 0) {
        alert('Nije dozvoljena prijava na više od jedne grupe.');

        return;
      }
      this.openedFlyTalkGroup = flyTalk;
      this.applicationModalIsVisible = true;
      document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
      this.openedFlyTalkGroupId = flyTalk.Id;
    },
    closeApplicationModal: function() {
      this.openedFlyTalkGroup = {};
      this.applicationModalIsVisible = false;
      document.getElementsByTagName('body')[0].style.overflowY = 'scroll';
      this.openedFlyTalkGroupId = null;
      this.eventApplication = {};
    },
    getCompanyNameNormalized: function(companyName) {
      return companyName.replace(/\s/g, '').toLowerCase();
    },
    getCompanyLogo: function(companyName) {
      const sponsorNameNormalized = this.getCompanyNameNormalized(companyName);

      // eslint-disable-next-line
      return require(`@/assets/companies/logos/${sponsorNameNormalized}.${this.sponsorLogoExtensions[sponsorNameNormalized]}`);
    },
    getDayInCroatian: function(dayIndex) {
      switch (dayIndex) {
        case 1:
          return 'Ponedjeljak';
        case 2:
          return 'Utorak';
        case 3:
          return 'Srijeda';
        case 4:
          return 'Četvrtak';
        case 5:
          return 'Petak';
        case 6:
          return 'Subota';
        case 7:
          return 'Nedjelja';
        default:
          return '';
      }
    },
    applyToFlyTalk: function(eventApplication, cvFile) {
      const formFile = new FormData();
      formFile.append('model', JSON.stringify({ ...eventApplication, eventId: this.openedFlyTalkGroupId }));
      formFile.append('cvFile', cvFile);
      this.$axios
        .post(`${this.$API_URL}/user/apply-fly-talk`, formFile, { headers: { 'content-type': 'multipart/form-data' } })
        .then(() => {
          alert('Prijava na događaj uspješna!');
          this.appliedFlyTalksIds.push(this.openedFlyTalkGroupId);
        })
        .finally(() => {
          this.applicationModalIsVisible = false;
        });
    },
    removeFlyTalk: function(eventId) {
      if (!this.appliedFlyTalksIds.includes(eventId)) return;
      this.$axios
        .post(`${this.$API_URL}/user/remove-apply`, {
          eventId: eventId,
        })
        .then(() => {
          alert('Odjava s događaja uspješna! Žao nam je što ipak nećeš doći :(');
          this.appliedFlyTalksIds.splice(
            this.appliedFlyTalksIds.findIndex(id => id === eventId),
            1,
          );
        })
        .catch(() => {
          alert('Odjava s događaja neuspješna. Molimo te pokušaj opet.');

          return;
        });
    },
    getYears: function() {
      let currentYear = new Date().getFullYear();
      let years = [];
      let startYear = 1950;
      while (startYear <= currentYear) years.push(startYear++);

      return years.reverse();
    },
  },
};
</script>

<style scoped>
.not-ready-notice {
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
}
.fly-talks-information {
  display: flex;
  margin-top: 30px;
  margin-bottom: 110px;
  margin-right: 100px;
}
.fly-talks-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
}
.fly-talks-cta div {
  margin-bottom: 20px;
}
.fly-talks-cta div img {
  margin-right: 15px;
  width: 10px;
}
.fly-talks-cta div span {
  color: #7a8e94;
  font-size: 18px;
  line-height: 20px;
}
.fly-talks-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-right: 100px;
}
.fly-talk {
  margin-right: 30px;
  flex-basis: 275px;
  display: flex;
  flex-direction: column;
}
.fly-talk-box {
  flex-grow: 1;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  padding: 30px;
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
}
.fly-talk-company-images {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.fly-talk-button-wrapper {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
}
.fly-talk-company-images div {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
.fly-talk-company-images img {
  max-width: 120px;
  margin-bottom: 20px;
}
.fly-talk-title {
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
}
.fly-talk-time {
  margin: 10px 0;
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
}
.fly-talks-apply {
  cursor: pointer;
  border: none;
  padding: 10px 30px;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  background: #30cec2;
  border-radius: 15px;
  color: black;
  width: fit-content;
  text-decoration: none;
  outline: none;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1);
}
.fly-talks-unapply {
  cursor: pointer;
  border: 2px solid #7a8e94;
  background: transparent;
  font-weight: bold;
  width: fit-content;
  font-size: 20px;
  border-radius: 10px;
  padding: 8px 30px;
  color: #7a8e94;
  text-decoration: none;
  outline: none;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1);
}
.fly-talks-apply:hover,
.fly-talks-unapply:hover {
  cursor: pointer;
  box-shadow: none;
  transition: box-shadow 0.2s ease-in-out, opacity 0.2s ease-in-out;
  opacity: 0.8;
}
.fly-talks-apply.max-participants {
  opacity: 0.5;
}
@media screen and (max-width: 1350px) {
  .fly-talks-information {
    margin-left: 50px;
  }
  .fly-talks-container {
    margin-right: 50px;
    padding-left: 50px;
    justify-content: center;
  }
  .fly-talks-information {
    margin-right: 50px;
  }
  .fly-talk-box {
    padding: 20px;
  }
  .fly-talks-apply,
  .fly-talks-unapply {
    padding: 10px 15px;
    font-size: 16px;
  }
  .fly-talk-company-images img {
    margin-bottom: 15px;
  }
}
@media screen and (max-width: 1024px) {
  .fly-talks-information {
    flex-wrap: wrap;
    margin-bottom: 0;
  }
  .fly-talks-container {
    margin-right: 0;
    overflow-x: auto;
    padding-right: 20px;
    padding-bottom: 40px;
  }
  .fly-talks-cta {
    align-items: flex-start;
    margin-top: 30px;
  }
  .fly-talk {
    padding-right: 40px;
    flex-basis: 300px;
  }
  .fly-talk-box {
    width: 100%;
    box-sizing: border-box;
  }
}
@media screen and (max-width: 700px) {
  .fly-talk {
    padding-right: 0;
    margin-right: 0;
  }
}
@media screen and (max-width: 600px) {
  .fly-talks-information {
    margin-left: 20px;
    margin-right: 18px;
  }
  .fly-talks-cta div span,
  .fly-talk-time {
    font-size: 14px;
    line-height: 17px;
  }
  .fly-talks-container {
    padding-left: 20px;
  }
  .fly-talk-title {
    font-size: 18px;
    line-height: 22px;
  }
  .fly-talks-apply,
  .fly-talks-unapply {
    font-size: 14px;
    line-height: 17px;
    padding: 14px 23px;
  }
}
</style>
